import React from 'react';
import PropTypes from 'prop-types';
import FlexContainer from '../FlexContainer/FlexContainer.jsx';
import css from './ChartLegendItem.module.scss';

const ChartLegendItem = ({
  label,
  color,
  className = '',
  style = {},
}) => {
  return (
    <FlexContainer 
      className={`${css.chartLegendItem} ${className}`}
      alignItems="center" 
      flexWrap="nowrap" 
      gap={10}
      style={style}
    >
      <div
        className={css.labelLegend}
        style={{backgroundColor: color}}
      />
      <span>{label}</span>
    </FlexContainer>
  );
};

ChartLegendItem.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default ChartLegendItem;

